import React from 'react';
import { observer } from 'mobx-react';
import ChatNote from '../ChatNote';
import ListPreloader from '../../../../Base/Utils/ListPreloader';
import blankProfilePicture from "../../../../../assets/avatars/blankProfilePicture.png";
import styles from './ChatNotesList.module.scss';
const ChatNotesList = ({ notesList, loading, handleDeleteNote, getAgent, hasPermission, highlightedNoteId, handleOnClickNote, handleEditNote, editingNoteId }) => {
    const renderNotes = () => {
        if (loading) {
            return React.createElement(ListPreloader, null);
        }
        if (!notesList.length) {
            return null;
        }
        return notesList.slice().reverse().map((note) => {
            const agent = getAgent(note);
            return (React.createElement(ChatNote, { key: String(note._id), _id: String(note._id), avatar: blankProfilePicture, text: note.text, agentTitle: (agent === null || agent === void 0 ? void 0 : agent.displayName) || (agent === null || agent === void 0 ? void 0 : agent.email) || '', createdAt: note.createdAt, handleDeleteNote: () => handleDeleteNote(note), onClick: () => handleOnClickNote(note), hasPermission: hasPermission(note), highlighted: String(note._id) === highlightedNoteId, handleEditNote: () => handleEditNote(note), isEditing: editingNoteId === String(note._id) }));
        });
    };
    return React.createElement("div", { className: styles.container }, renderNotes());
};
export default observer(ChatNotesList);
